



































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CreditScore from "./CreditScore.vue";
import * as services from "@/services/credittrust";
import { CreditTrustDTO } from "@/api/credittrust/types";
import { Analysis} from "@/api/analyses/types";

@Component({
  name: "CreditScoreController",
  components: {
    CreditScore,
  },
})
export default class CreditScoreController extends Vue {
  @Prop({ type: Object, required: true })
  private analysis!: Analysis;

  @Prop({ type: String, required: false, default: undefined })
  private harvestSeason?: string;

  @Prop({ type: String, required: false, default: undefined })
  private cropType?: string;

  private scores: CreditTrustDTO | null = null;

  private loaded = false;
  private pooling: number | null = null

  private async mounted() {
    await this.loadChartData();
  }

  private async loadChartData() {
    this.$emit('update:loading', true);
    try {
      this.scores = await services.getByUuid(this.analysis.uuid, this.harvestSeason, this.cropType);
      this.poolIfNotReady();
      this.loaded = true;
    } catch {
      this.loaded = false;
    } finally {
      this.$emit('update:loading', false);
    }
  }

  get fetchKey() {
    return `${this.harvestSeason}:${this.cropType}`;
  }

  @Watch('fetchKey')
  private async onFetchKeyChange() {
    if (this.pooling) {
      clearTimeout(this.pooling);
      this.pooling = null;
    }
    await this.loadChartData();
  }

  private poolIfNotReady() {
    if (this.scores?.status === 'PROCESSING') {
      this.pooling = setTimeout(async () => {
        await this.loadChartData();
      }, 1000);
    }
  }

  private beforeDestroy() {
    if (!!this.pooling) {
      clearTimeout(this.pooling);
    }
  }
}
